import React, { CSSProperties, FC } from 'react';

import { cn } from '../../../../utils';

export type PlusIconPreset = 'default' | 'success' | 'muted' | 'circle-filled';

type OwnProps = {
  preset?: PlusIconPreset;
  size?: number;
  className?: string;
  style?: CSSProperties;
  title?: string;
};

type Props = OwnProps & Omit<React.SVGProps<SVGSVGElement>, keyof OwnProps>;

const PlusIcon: FC<Props> = ({
  preset = 'default',
  size = 24,
  className,
  style,
  title = 'Plus',
  ...svgProps
}) => {
  const isFilledCircle = preset === 'circle-filled';
  const hasSquareBg = preset === 'muted';

  const iconColor =
    preset === 'success'
      ? 'var(--primary-green-new)'
      : preset === 'muted' || preset === 'circle-filled'
        ? 'var(--white-color)'
        : '#111';

  const backgroundColor = hasSquareBg ? 'var(--gray-color-3)' : undefined;

  const strokeWidth = 1.5;
  const innerScale = isFilledCircle ? 0.75 : hasSquareBg ? 0.85 : 1;

  return (
    <svg
      className={cn(className)}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title}
      style={{ width: size, height: size, color: iconColor, ...style }}
      {...svgProps}
    >
      {backgroundColor ? <rect x="0" y="0" width="24" height="24" fill={backgroundColor} /> : null}
      {isFilledCircle ? <circle cx="12" cy="12" r="11" fill="var(--primary-green-new)" /> : null}

      <g
        transform={
          innerScale !== 1 ? `translate(12 12) scale(${innerScale}) translate(-12 -12)` : undefined
        }
      >
        <path
          d="M12 6L12 18"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
        />
        <path
          d="M18 12L6 12"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
};

export default PlusIcon;
